import {
    ACTIVATE_UTR_AUTHENTICATE,
    ACTIVATE_UTR_AUTHENTICATE_FAILED,
    ACTIVATE_UTR_AUTHENTICATE_SUCCESS,
    ACTIVATE_UTR_CLEAR_DATA,
    CONNECT_PLAYER_THIRD_PARTY_ID,
    CONNECT_PLAYER_THIRD_PARTY_ID_SUCCESS,
    CONNECT_PLAYER_THIRD_PARTY_ID_FAILURE,
} from '../actions/actionTypes/activate-utr-types';

const initialState = {
    isLoading: false,
    isErrored: false,
    activationType: null,
    activationToken: null,
    user: null,
    redirectToken: null,
};

function app(state = initialState, action) {
    switch (action.type) {
        case ACTIVATE_UTR_AUTHENTICATE:
            return {
                ...state,
                isLoading: true,
                isErrored: false,
                activationType: action.data.activationType,
                activationToken: action.data.activationToken,
            };
        case ACTIVATE_UTR_AUTHENTICATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isErrored: false,
                user: action.data.user,
            };
        case ACTIVATE_UTR_AUTHENTICATE_FAILED:
            return {
                ...state,
                isLoading: false,
                isErrored: true,
                user: null,
            };
        case CONNECT_PLAYER_THIRD_PARTY_ID:
            return {
                ...state,
                isLoading: true,
                isErrored: false,
                redirectToken: null,
            };
        case CONNECT_PLAYER_THIRD_PARTY_ID_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isErrored: false,
                redirectToken: action.data.redirectToken,
            };
        case CONNECT_PLAYER_THIRD_PARTY_ID_FAILURE:
            return {
                ...state,
                isLoading: false,
                isErrored: true,
                redirectToken: null,
            };
        case ACTIVATE_UTR_CLEAR_DATA:
            return {
                ...state,
                ...initialState,
            };
        default:
            return state;
    }
}

export default app;
